import { AxiosInstance } from 'axios';
import type { CompareOverviewRecord } from './SalesforceService';

export default class XmlService {
  private readonly client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getDiff(record: CompareOverviewRecord): Promise<string> {
    const { data } = await this.client.post<string>(
      '/apis/xml-diff/v1/comparable',
      {
        record,
      }
    );
    return data;
  }

  async getXmlFromComparable(
    comparable: Record<string, unknown>
  ): Promise<string> {
    const { data } = await this.client.post<string>('/apis/xml-diff/v1/xml', {
      comparable,
    });
    return data;
  }
}
